import { render, staticRenderFns } from "./ProductAmountRank.vue?vue&type=template&id=7c5497bc&scoped=true&"
import script from "./ProductAmountRank.vue?vue&type=script&lang=js&"
export * from "./ProductAmountRank.vue?vue&type=script&lang=js&"
import style0 from "./ProductAmountRank.vue?vue&type=style&index=0&id=7c5497bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5497bc",
  null
  
)

export default component.exports